import React, { useState, useEffect } from 'react';
import UploadSection from '../components/UploadSection';
import VideoUploadSection from '../components/VideoUploadSection';
import axios from 'axios';
import routes from '../api_routes';
import s3config from '../s3_config';

import './ChannelSection.css'
import UploadSummary from './UploadSummary';

const ChannelSection = ({initialData, toastContainer, startExpanded}) => {

    const [channelData, setChannelData] = useState(initialData);
    const [channelName, setChannelName] = useState("");
    const [channelDescription, setChannelDescription] = useState("");
    const [avatarUploadState, setAvatarUploadState] = useState();
    const [uploadsLoading, setUploadsLoading] = useState(false);
    const [uploads, setUploads] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [refresh, setRefresh] = useState(0);
    const [collapsibleState, setCollapsibleState] = useState(startExpanded === true ? '' : 'CollapsibleContent');

    const episodeApiUrl = routes.upload;
    const channelApiUrl = routes.channel;
  
    const channelAvatarApiUrl = () => { return routes.channel + "/avatar/" + initialData.id };
    const channelBannerApiUrl = () => { return routes.channel + "/banner/" + initialData.id };
    const videoListApiUrl = routes.upload_states + `/${initialData.id}`;

    const fromS3URL = (oldUrl) => {
      if(oldUrl === null || oldUrl === undefined || oldUrl === '') {
        return '';
      }
      
      // oldUrl: s3://hf-public-content/iqSZOyBu/avatar.webp
      // newUrl: https://hf-public-content.s3.us-east-1.amazonaws.com/iqSZOyBu/avatar.webp
      const re = /(?<prefix>s3:\/\/)(?<bucket>([a-z]*|[-]*)*)\/(?<channel>[a-zA-Z0-9]{8})(\/)*(?<episode>[a-zA-Z0-9]{8})*\/(?<filename>.*)/g;
      try {
        const {groups: {prefix, bucket, channel, episode, filename}} = re.exec(oldUrl);
        if(prefix && prefix === "s3://") {
          let newUrl = `https://${bucket}.s3.${s3config.region}.amazonaws.com/${channel}`;
          if (episode && episode.length > 0) {
            newUrl += `/${episode}`;
          }
          newUrl += `/${filename}`;
          return newUrl;
        }
      }
      catch(ex) {
        console.log("Data already transformed");
      }

      return oldUrl;
    }

    useEffect( () => {
        const getChannelData = async() => {
            const token = localStorage.getItem('token');
            if (token) {                
              console.log("Initial data: %o", initialData);
              initialData.avatar = fromS3URL(initialData.avatar);
              initialData.banner = fromS3URL(initialData.banner);
              initialData.trailer_img = fromS3URL(initialData.trailer_img);
              initialData.trailer_url = fromS3URL(initialData.trailer_url);
              console.log("Transformed URLs: %o", initialData);

              setChannelData(initialData);
              setChannelName(initialData.name);
              setChannelDescription(initialData.description);

              setUploadsLoading(true);
              const videos = await axios.get(videoListApiUrl, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
              });

              console.log("Video data: %o", videos);

              const avatarState = await axios.get(channelAvatarApiUrl());
              console.log("avatar state: %o", avatarState);
              setAvatarUploadState(avatarState.data.processing_status);

              const filteredUploads = filterUploadsByEvent(videos.data);
              setUploads(filteredUploads);
              setUploadsLoading(false);
            }
        }

        getChannelData();
    }, [refresh]);

    const filterUploadsByEvent = (uploaded_videos) => {
      let result = {};
      for(const video of uploaded_videos) {
        if(video.id in result) {
          //highest priority, always record
          if(video.event_status === 'processed') {
            result[video.id] = video;
          }
          //lowest priority, always overwrite
          else if(result[video.id].event_status === 'unprocessed') {
            result[video.id] = video;
          }
        }
        else {
          result[video.id] = video;
        }
      }

      //sort by latest episode
      const result_array = Object.values(result).sort((a, b) => {
        if(a.date > b.date) return -1;
        if(a.date < b.date) return 1;
        return 0;
      });

      return result_array;
    }
    const handleSaveChannelData = async (e) => {
        setIsSaving(true);
        let newData = {...channelData};
        newData.name = channelName;
        newData.description = channelDescription;
        
        const token = localStorage.getItem('token');
    
        console.log("%o", newData);
    
        await axios.put(channelApiUrl, newData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
        }).finally(() => {
          setIsSaving(false);
          setChannelData(newData);
        });
      }
    
      const handleNameChange = (e) => {
        const t = e.target.value;
        if (t !== null && t !== undefined && t.length > 0) {
            setChannelName(t);
        }
      };
    
      const handleDescriptionChange = (e) => {
        const t = e.target.value;
        if (t !== null && t !== undefined && t.length > 0) {
            setChannelDescription(t);
        }
      };
    
      const updateToast = (state, description) => {
        state ? toastContainer.success(description) : toastContainer.error(description);
      }
    
      const updateToastAndUploads = (state, description) => {
        setRefresh(refresh+1);
        updateToast(state, description);
      }

      const toggleCollapsible = (e) => {
        if(collapsibleState === "") {
          setCollapsibleState("CollapsibleContent");
        }
        else {
          setCollapsibleState("");
        }
      }

    return (
        <div className="UploadArea">
        <button onClick={toggleCollapsible} className="Collapsible"><h2>{collapsibleState.length>0?'＋':'－'} {channelData.name}</h2></button>
        <span className={`ChannelDetailSplit ${collapsibleState}`}>
          <div className="ChannelDetailColumn">
            <h4 className="MajorSubheader">Channel information</h4>

            <div className="BottomGap">
                <label htmlFor={`${channelData.id}-upload-name`} className="FieldLabel">
                    Channel name
                </label>
                <span className="InputButtonPair">
                  <input className="TextInput" type="text" id={`${channelData.id}-upload-name`} onChange={handleNameChange} value={channelName}/>
                  <button disabled={isSaving} onClick={handleSaveChannelData} className="StandardButton">Save</button>
                </span>
            </div>
            <div className="BottomGap">
                <label htmlFor={`${channelData.id}-upload-description`} className="FieldLabel">
                    Channel description
                </label>
                <span className="InputButtonPair">
                  <textarea type="text" cols={40} id={`${channelData.id}-upload-description`} onChange={handleDescriptionChange} value={channelDescription} className=""/>
                  <button disabled={isSaving} onClick={handleSaveChannelData} className="StandardButton">Save</button>
                </span>
            </div>

            <UploadSection keyId={`${channelData.id}-avatar`} name="Avatar" uploadDisabled={false} uploadState={avatarUploadState} initialData={channelData.avatar} uploadLabel={"Change avatar"} uploadUrl={channelAvatarApiUrl()} setUploadResult={updateToast}></UploadSection>

            <div className="ButtonBreak"></div>
            
            <UploadSection keyId={`${channelData.id}-banner`}name="Banner" uploadDisabled={true} initialData={channelData.banner} uploadLabel={"Change banner"} uploadUrl={channelBannerApiUrl()} setUploadResult={updateToast}></UploadSection>

            <div className="ButtonBreak"></div>

            <UploadSection keyId={`${channelData.id}-trailer-img`} name="Trailer image" uploadDisabled={true} initialData={channelData.trailer_img} uploadLabel={"Change trailer image"} uploadUrl={channelApiUrl} setUploadResult={updateToast}></UploadSection>
            
            <div className="ButtonBreak"></div>
            
            <UploadSection keyId={`${channelData.id}-trailer-vid`} name="Trailer video" uploadDisabled={true} initialData={channelData.trailer_url} uploadLabel={"Change trailer video"} uploadUrl={channelApiUrl} setUploadResult={updateToast}></UploadSection>

          </div>
          <div className="ChannelDetailColumn">
            <h4 className="MajorSubheader">Episodes</h4>
            <form>
            <VideoUploadSection keyId={channelData.id} name="Upload new episode" initialData={null} uploadUrl={episodeApiUrl+`/${channelData.id}`} setUploadResult={updateToastAndUploads} clearOnSuccess={true}></VideoUploadSection>
            
            </form>
            <div className="ButtonBreak"></div>

            <h4>Past episodes</h4>
            <div className="PastUploadsArea">
              {uploadsLoading ? <p>Loading...</p> :
                uploads?.length > 0 ? 
                <div>
                  {uploads.map((video) => {
                    return (
                    <UploadSummary update_url={episodeApiUrl} video_id={video.id} title={video.title} description={video.description} event_status={video.event_status}/>
                    );
                  })}
                </div> :
                <p>No episodes have been uploaded.</p>
              }
            </div>
          </div>
        </span>
        </div>
    );
}

export default ChannelSection;